import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import MarqueeBar from "@/components/site/MarqueeBar";
import MenuShowcase from "@/components/site/MenuShowcase";
import About from "@/components/site/About";
import Reviews from "@/components/site/Reviews";
import Gallery from "@/components/site/Gallery";
import Reservation from "@/components/site/Reservation";
import ContactMap from "@/components/site/ContactMap";
import Footer from "@/components/site/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";

const Safe = ({ children }) => <ErrorBoundary>{children}</ErrorBoundary>;

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen text-[#1A1A1A]">
      <Safe><Navbar /></Safe>
      <main>
        <Safe><Hero /></Safe>
        <Safe><MarqueeBar /></Safe>
        <Safe><MenuShowcase /></Safe>
        <Safe><About /></Safe>
        <Safe><Gallery /></Safe>
        <Safe><Reviews /></Safe>
        <Safe><Reservation /></Safe>
        <Safe><ContactMap /></Safe>
      </main>
      <Safe><Footer /></Safe>
    </div>
  );
}
